<template>
    <Transition name="modal-fade">
        <div v-if="isdisplay" class="cf-overlay" @click.self="close">
            <Transition name="modal-slide">
                <div v-if="isdisplay" class="cf-dialog cf-dialog--sm">

                    <!-- Header -->
                    <div class="cf-modal-head cf-dialog-head">
                        <div class="cf-modal-head__main">
                            <span class="cf-modal-head__icon" style="color:rgb(var(--danger));background:#fee2e2;"><i class="ri-error-warning-line"></i></span>
                            <div>
                                <h4 class="cf-dialog-title">CORRECTION DES TRANSFERTS DE CAISSE</h4>
                                <p class="cf-modal-head__sub">Confirmation requise — opération irréversible</p>
                            </div>
                        </div>
                        <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                    </div>

                    <!-- Body -->
                    <div class="cf-dialog-body">
                        <div v-if="messagesucces!==''" class="cf-note cf-note--info" style="margin-bottom:0.75rem;">
                            <i class="ri-check-circle-line"></i><span v-html="messagesucces"></span>
                        </div>
                        <div v-if="messageerror!==''" class="cf-note cf-note--danger" style="margin-bottom:0.75rem;">
                            <i class="ri-error-warning-line"></i><span v-html="messageerror"></span>
                        </div>

                        <strong style="color:var(--cf-ink-strong);">{{ titlemodal }}</strong>

                        <div class="cf-note cf-note--danger" style="margin-top:0.75rem;">
                            <i class="ri-alert-line"></i>
                            <span>
                                <strong style="display:block; margin-bottom:4px; text-transform:uppercase; letter-spacing:.03em;">
                                    Opération irréversible
                                </strong>
                                Cette opération va corriger <strong>toutes</strong> les opérations de transfert de caisse mal effectuées
                                dans la période sélectionnée. Elle ne peut pas être annulée après confirmation.
                                <br><br>
                                Veuillez vérifier attentivement vos données et, si possible, imprimez le point de caisse de la période avant de continuer.
                            </span>
                        </div>

                        <label class="cf-checkrow">
                            <input class="form-check-input" type="checkbox" v-model="checkok">
                            <span>Cochez pour confirmer que vous comprenez les risques et souhaitez continuer.</span>
                        </label>
                    </div>

                    <!-- Footer -->
                    <div class="cf-dialog-foot">
                        <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Non, annuler</button>
                        <button :disabled="!checkok" @click="btnsuppression" type="button" class="ti-btn ti-btn-danger-full">
                            <i class="ri-alert-line align-middle"></i> Oui, corriger
                        </button>
                    </div>

                </div>
            </Transition>
        </div>
    </Transition>
</template>

<script>

    //import allfunction from "@/allfunction";
    import {randomString} from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";
    const axios =require('axios');

    export default {
        /* eslint-disable */
        name: "formsupp",
        data() {
            return {
                isdisplay: false,
                titlemodal: "",
                Items: {},
                checkok: false,
                messageerror: "",
                messagesucces: "",
            };
        },
        methods: {

            close() {
                this.isdisplay = false;
                this.$emit('closed');
            },

            show(titlemodal, Items) {
                this.messagesucces = "";
                this.messageerror = "";
                this.titlemodal = titlemodal;
                this.Items = Items;
                this.checkok = false;
                this.isdisplay = true;
            },

            async  btnsuppression(){

                if (this.checkok===false){return }

                this.$store.dispatch('lancerchargement',true)
                const t = this;
                let url=process.env.VUE_APP_API_URL+'/utilitaire/maj/'+this.$store.state.appsociete+'/correctiontransfertapproc/'+randomString();
                let response =   axios  .post(url,this.Items,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        // t.$store.dispatch('beartoken',res.data.beartoken)
                        t.$store.dispatch('lancerchargement',false)
                        if(res.data.success){

                            t.messagesucces="";
                            t.messageerror="";

                            t.messagesucces=res.data.message;

                            toastr['success']( t.messagesucces,"<b></b>");


                            t.close()

                        }
                        else{
                            t.messageerror = "";
                            t.messagesucces = "";
                            t.messageerror = res.data.datamessage?.length > 0
                                ? res.data.datamessage.join(' , ')
                                : res.data.message;
                            toastr['error'](t.messageerror, "<b></b>");
                        }


                    })
                    .catch(

                        error => toastr['error']( "Une erreur est subvenue. <br/> veuillez contacter votre administrateur.",
                            "<b>Erreur</b>")
                    )
                    .finally(() => this.$store.dispatch('lancerchargement',false))


            },








        },
        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>

    .form-check-input {
        height: 1.9rem;
        width: 1.9rem;
        border-radius: 0.25rem;
        border-width: 1px;
        border-style: solid;
        border-color: rgb(var(--input-border));
        --tw-bg-opacity: 1;
        background-color: #fff;
        cursor: pointer;
    }

</style>